import { useLocation } from 'react-router-dom';
import { Image } from 'react-bootstrap';
import BannerImg from '../../../Assets/Img/BannerWebP.webp'
import './Banner.css';

function Banner() {
    const location = useLocation(); // 이제 App.js의 Router 안에서 실행되므로 정상 작동합니다.

    const pageTitles = {
        '/': '법률사무소 온평',
        '/onpyeong': '온평 소개',
        '/fields': '업무 분야',
        '/profile': '변호사 프로필',
        '/case': '성공 사례',
        '/contact': '상담 요청',
        '/location': '오시는 길'
    };

    // 현재 경로에 맞는 제목 찾기 (대소문자 구분 주의)
    const currentTitle = pageTitles[location.pathname] || '법률사무소 온평';

    return (
        <div className="banner-wrapper">
            <Image src={BannerImg} className="main-banner-img" fluid />
            <div className="banner-overlay">
                <h1 className="banner-title">{currentTitle}</h1>
            </div>
        </div>
    );
}

export default Banner;